export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			value: '',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Estado de Movimiento de deposito',
	plural_model_name_spanish: 'Estados de Movimiento de deposito',
	create_model_name_spanish: 'Nuevo',
	text_delete: 'el',
}